import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirmation-dialog__content" }
const _hoisted_2 = { class: "confirmation-dialog__message-section" }
const _hoisted_3 = {
  viewBox: "0 0 24 24",
  width: "32",
  height: "32"
}
const _hoisted_4 = {
  key: 0,
  fill: "currentColor",
  d: "M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
}
const _hoisted_5 = {
  key: 1,
  fill: "currentColor",
  d: "M13 14H11V9H13M13 18H11V16H13M1 21H23L12 2L1 21Z"
}
const _hoisted_6 = {
  key: 2,
  fill: "currentColor",
  d: "M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z"
}
const _hoisted_7 = {
  key: 3,
  fill: "currentColor",
  d: "M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z"
}
const _hoisted_8 = { class: "confirmation-dialog__text" }
const _hoisted_9 = {
  key: 0,
  class: "confirmation-dialog__message"
}
const _hoisted_10 = { class: "confirmation-dialog__actions" }

import { ref, watch, nextTick, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import AppModal from '../../base/Modal.vue';
import AppButton from '../../base/AppButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmationDialog',
  props: {
    show: { type: Boolean },
    title: {},
    message: {},
    confirmButtonText: {},
    cancelButtonText: {},
    confirmButtonType: {},
    icon: {},
    iconType: {},
    isLoading: { type: Boolean }
  },
  emits: ["update:show", "confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props;

const emit = __emit;

const { t } = useI18n();
const cancelBtn = ref<any>(null);

const confirm = (close?: () => void) => {
  emit('confirm');
  if (close) close();
};

const cancel = (close?: () => void) => {
  emit('cancel');
  if (close) close();
};

// Compute button variant based on type
const confirmButtonVariant = computed(() => {
  const variants: Record<string, string> = {
    primary: 'primary',
    danger: 'danger',
    warning: 'warning',
    success: 'success'
  };
  return variants[props.confirmButtonType || 'primary'] || 'primary';
});

// Watch for dialog visibility and focus management
watch(() => props.show, (newVal: boolean | undefined) => {
  if (newVal) {
    nextTick(() => {
      if (cancelBtn.value && cancelBtn.value.$el) {
        cancelBtn.value.$el.focus();
      }
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppModal, {
    show: _ctx.show,
    title: _ctx.title,
    size: 'medium',
    gradientHeader: false,
    loading: _ctx.isLoading,
    closeOnBackdropClick: true,
    onClose: cancel
  }, {
    footer: _withCtx(({ close }) => [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(AppButton, {
          type: "button",
          variant: "outline",
          onClick: () => cancel(close),
          ref_key: "cancelBtn",
          ref: cancelBtn,
          disabled: _ctx.isLoading,
          class: "confirmation-dialog__btn confirmation-dialog__btn--cancel"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.cancelButtonText), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"]),
        _createVNode(AppButton, {
          type: "button",
          variant: confirmButtonVariant.value,
          onClick: () => confirm(close),
          disabled: _ctx.isLoading,
          loading: _ctx.isLoading,
          class: "confirmation-dialog__btn confirmation-dialog__btn--confirm"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.confirmButtonText), 1)
          ]),
          _: 1
        }, 8, ["variant", "onClick", "disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.iconType)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["confirmation-dialog__icon", `confirmation-dialog__icon--${_ctx.iconType}`])
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_3, [
                  (_ctx.iconType === 'info')
                    ? (_openBlock(), _createElementBlock("path", _hoisted_4))
                    : (_ctx.iconType === 'warning')
                      ? (_openBlock(), _createElementBlock("path", _hoisted_5))
                      : (_ctx.iconType === 'danger')
                        ? (_openBlock(), _createElementBlock("path", _hoisted_6))
                        : (_ctx.iconType === 'success')
                          ? (_openBlock(), _createElementBlock("path", _hoisted_7))
                          : _createCommentVNode("", true)
                ]))
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.message)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.message), 1))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ])
    ]),
    _: 3
  }, 8, ["show", "title", "loading"]))
}
}

})